import { render, staticRenderFns } from "./CheckRiskModule.vue?vue&type=template&id=4504ee47&scoped=true&"
import script from "./CheckRiskModule.vue?vue&type=script&lang=js&"
export * from "./CheckRiskModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4504ee47",
  null
  
)

export default component.exports